const styles = theme => ({
    root: {
        padding: 0
    },
    avatar: {
        width: 80,
        height: 80,
        marginRight: theme.spacing(2)
    },
    listItem: {
        borderBottom: `solid 1px ${theme.palette.common.border}`
    },
    list: {
        borderLeft: `solid 1px ${theme.palette.common.border}`,
        borderRight: `solid 1px ${theme.palette.common.border}`,
        borderTop: `solid 1px ${theme.palette.common.border}`,
        paddingBottom: 0
    }
});

export default styles;